module.exports = __webpack_public_path__ + "static/media/AyurvedicProducts.29bc9bb7.jpg";